import React, { useEffect, useRef, useState } from "react";
import * as L from '../../style/StyleComponentLogin';
// import { useSelector } from "react-redux";
// import { RootState } from "../../redux/Store";
import { login_request, logout_request } from "../../Axios";
import { useNavigate } from "react-router-dom";
import background_image_1 from "../../assets/images/bg_b2b_1.png";
import background_image_2 from "../../assets/images/bono.jpeg";
import background_image_3 from "../../assets/images/Jazz-Piano-with-George-Whitty-Image.jpg";
import background_image_4 from "../../assets/images/composition8.jpg";

const Login: React.FC = () => {
    const navigate = useNavigate();
    // const testData = useSelector((state: RootState) => state.testData);
    const [idModal, setIdModal] = useState<boolean>(false);
    const [passwordModal, setPasswordModal] = useState<boolean>(false);
    const [customerEmail, setCustomerEmail] = useState<string>('');
    const [customerPassword, setCustomerPassword] = useState<string>('');
    const [selectedBackground, setSelectedBackground] = useState<string>("");

    const emailRef: React.RefObject<HTMLInputElement> = useRef(null);
    const passwordRef: React.RefObject<HTMLInputElement> = useRef(null);

    const offModal = (e:any) => {
        if(e.target === e.currentTarget) {
            setIdModal(false);
            setPasswordModal(false);
        }
    };

    useEffect(() => {
        logout_request().then();
    }, []);

    useEffect(() => {
        onMountMainBackground();
        onMountFocusInput();
    }, []);

    // 배경 이미지 랜덤 FIXME: 이거 나중에 폴더 째로 배열로 만들기
    const onMountMainBackground = () => {
        let num = Math.floor(Math.random() * 1);
        let list = [background_image_1, background_image_2, background_image_3, background_image_4];
        setSelectedBackground(list[num]);
    };

    // 페이지 렌더링 시 input에 포커싱
    const onMountFocusInput = () => {
        if(passwordRef.current) {
            passwordRef.current.focus();
        }
    };

    // 로그인 요청
    const handleLogin = () => {
        // TODO: 유효성 검사
        if(customerEmail.trim() === "") {
            return alert('이메일을 입력하세요');
        }
        if(customerPassword.trim() === "") {
            return alert('비밀번호를 입력하세요');
        }
        
        try {
            login_request(customerEmail, customerPassword).then(result => {
                if(result === 1) {
                    navigate('/main');
                } else {
                    alert('로그인이 실패하였습니다.');
                }
            });
        }
        catch (err) {
            console.log(err);
        }
    };

    return (
        <L.LoginContainer $background={selectedBackground}>
            <L.LoginHeader>
                <ul>
                    <li className="login-top-bar-logo">
                        <img src={require('../../assets/images/ablack_logo_w.png')} alt="" width="100%" />
                    </li>
                    <li className="login-top-bar-text">
                        <p>A.Black B2B 통합 관리 시스템</p>
                    </li>
                </ul>
            </L.LoginHeader>
            <L.LoginWrap>
                <div className="login-title-box">
                    <div className="login-title">
                        <p>A.Black B2B</p>
                    </div>
                    <div className="login-sub-title">
                        <p className="sm:hidden md:hidden">
                            수입조명 시공 전문 인스톨러가 <br />
                            당신의 공간에 빛을 선물합니다.
                        </p>
                        <p>A.Black B2B 통합 관리 시스템</p>
                    </div>
                </div>
                <div className="login-con-wrap">
                    <div className="login-content">
                        <div className="logo-box">
                            <img src={require('../../assets/images/ablack_logo.png')} alt="" />
                        </div>
                        <div className="login-user-info">
                        <input
                            onChange={(e) => setCustomerEmail(e.target.value)}
                            value={customerEmail}
                            type="text"
                            className="user-input"
                            placeholder="이메일을 입력하세요."
                            ref={emailRef}
                            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                if (e.key === 'Enter') handleLogin();
                            }}
                        />
                        <input
                            onChange={(e) => setCustomerPassword(e.target.value)}
                            value={customerPassword}
                            type="password"
                            className="user-input"
                            placeholder="비밀번호를 입력하세요."
                            ref={passwordRef}
                            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                if (e.key === 'Enter') handleLogin();
                            }}
                        />
                        <button onClick={() => {handleLogin()}} type="submit" className="login-btn">로그인</button>
                        </div>
                        <div className="login-a1">
                            <div className="login-check-box">
                                {/* 이거 정렬 맞추기 */}
                                <input type="checkbox" className="login-check" />
                                <span className="text-sm">로그인 상태 유지</span>
                            </div>
                            <div className="find-user-info">
                                <span onClick={() => setIdModal(true)}>ID 찾기</span> &nbsp; | &nbsp;
                                <span onClick={() => setPasswordModal(true)}>비밀번호 찾기</span>
                            </div>
                        </div>
                        <div className="policy-box">
                            <button onClick={() => navigate('/privacy_policy_no_session')}>개인정보처리방침</button>
                            <button onClick={() => navigate('/terms_of_service_no_session')}>이용약관</button>
                        </div>
                    </div>
                </div>
            </L.LoginWrap>
            <L.mobileNotice>
                <div className="block md:hidden">
                    <p className="font-bold">본 웹은 PC버전에 특화된 웹 입니다.</p>
                </div>
            </L.mobileNotice>

            {idModal && 
                <L.ModalBack onClick={offModal}>
                    <div className="modal-container">
                        <div className="popup-close">
                            <p className="popup-title">아이디 찾기</p>
                        </div>
                        <div className="login-find-myinfo-input-box">
                            <div className="login-find-myinfo-input-box-con">
                                <input type="text" maxLength={13} placeholder="가입시 등록한 연락처를 입력하세요." />
                                <button type="button">인증요청</button>
                            </div>
                            <div className="login-find-myinfo-input-box-con">
                                <input type = "text"maxLength={10} placeholder = "인증번호를 입력하세요." />
                                <button type="button">인증확인</button>
                            </div>
                        </div>
                    </div>
                </L.ModalBack>
            }
            {passwordModal &&
                <L.ModalBack onClick={offModal}>
                    <div className="modal-container">
                        <div className="popup-close">
                            <p className="popup-title">비밀번호 찾기</p>
                        </div>
                        <div className="login-find-myinfo-input-box">
                            <div className="login-find-myinfo-input-box-con">
                                <input type="text" maxLength={50} placeholder="가입ID(이메일 형식)을 입력해주세요." />
                            </div>
                        </div>
                        <div className="login-find-myinfo-input-box">
                            <div className="login-find-myinfo-input-box-con">
                                <input type="text" maxLength={13} placeholder="가입시 등록한 연락처를 입력하세요." />
                                <button type="button">인증요청</button>
                            </div>
                            <div className="login-find-myinfo-input-box-con">
                                <input type="text" maxLength={10} placeholder="인증번호를 입력하세요." />
                                <button type="button">인증확인</button>
                            </div>
                        </div>
                    </div>
                </L.ModalBack>
            }
        </L.LoginContainer>
    )
};

export default Login;